<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div>
            <v-text-field v-model="fields['title-section']" label="Title" />
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.textColor"
                  @change="event => handleChangeTextColor(event)"
                />
                <v-text-field v-model="fields.textColor" label="Text Color" />
                <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="background-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.backgroundColor"
                  @change="event => handleChangeBackgroundColor(event)"
                />
                <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>

          <!-- Pagination Colors -->
          <div class="mt-4">
            <label class="label-input mb-4">Pagination Colors</label>
            <v-row>
              <v-col cols="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-active-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-active-color']"
                        @change="handleChangePaginationActiveColor"
                      />
                      <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                      <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-inactive-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-inactive-color']"
                        @change="handleChangePaginationInactiveColor"
                      />
                      <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                      <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Slides Per View -->
          <div class="mb-4">
            <label class="label-input">Slides Per View</label>
            <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
            <v-row>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.mobile.slidesPerView"
                    label="Mobile"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.tablet.slidesPerView"
                    label="Tablet"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.desktop.slidesPerView"
                    label="Desktop"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- <ckeditor :editor="editor" v-model="fields['content']" :config="editorConfig" /> -->
          <!-- Button View All -->
          <div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showBtn" style="margin-bottom: 0" class="label-input">Button</label>
              <input type="checkbox" v-model="fields.buttonViewAll.show" id="showBtn" />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.buttonViewAll.text" label="Button Text" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field type="number" v-model="fields.buttonViewAll.radius" label="Button Radius" />
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.buttonViewAll.color"
                        @change="event => handleChangeColorButton(event)"
                      />
                      <v-text-field v-model="fields.buttonViewAll.color" label="Button Color" />
                      <v-btn @click="handleResetColorButton" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.buttonViewAll.background"
                        @change="event => handleChangeBackgroundButton(event)"
                      />
                      <v-text-field v-model="fields.buttonViewAll.background" label="Button background" />
                      <v-btn @click="handleResetBackgroundButton" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="fields.buttonViewAll.link" label="Button Link" />
              </v-col>
            </v-row>
          </div>
          <!-- list item -->
          <div class="wrap-products-form">
            <div class="d-flex justify-space-between align-center mb-2">
              <label class="label-input" style="margin-bottom: 10px">List Item</label>
              <v-btn small text color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showText" style="margin-bottom: 0" class="">Show Text (Title, Description)</label>
              <input type="checkbox" v-model="fields.showText" id="showText" />
            </div>
            <v-row v-if="fields.showText">
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="head"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.itemTextColor"
                    @change="event => handleChangeItemTextColor(event)"
                  />
                  <v-text-field v-model="fields.itemTextColor" label="Item Text Color" />
                  <v-btn @click="handleResetItemTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="head"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.itemBackground"
                    @change="event => handleChangeItemBackground(event)"
                  />
                  <v-text-field v-model="fields.itemBackground" label="Item Background Color" />
                  <v-btn @click="handleResetItemBackground" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
            </v-row>
            <div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <span>Item {{ i + 1 }}</span>
                      <v-btn icon @click.stop="handleRemoveItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="wrap-product-form">
                      <v-text-field v-model="item.url" label="Url" />
                      <div class="mb-5">
                        <label> Image</label>
                        <UploadImage
                          @callback="obj => handleUploadImageItem(obj, i)"
                          :image="{ imageSrc: item.image }"
                          :height="`250`"
                          :typeUpload="'image'"
                          @callbackDelete="handleRemoveUploadItem(i)"
                        />
                      </div>
                      <v-textarea rows="2" outlined type="textarea" v-model="item.title" label="Title" />
                      <v-textarea outlined type="textarea" v-model="item.description" label="Description" />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'tino-grid-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        itemBackground: '#ffffff',
        backgroundColor: '',
        itemTextColor: '#000000',
        textColor: '',
        'pagination-active-color': '#000000',
        'pagination-inactive-color': '#cccccc',
        'title-section': '',
        showText: true,
        topPadding: true,
        bottomPadding: true,
        breakpoints: {
          mobile: {
            slidesPerView: 1,
          },
          tablet: {
            slidesPerView: 2,
          },
          desktop: {
            slidesPerView: 3,
          },
        },
        listItem: [
          {
            url: '',
            image: '',
            title: '',
            description: '',
          },
        ],
        buttonViewAll: {
          show: true,
          background: '#2d521d',
          color: '#ffffff',
          radius: 0,
          text: '',
          link: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleResetColorButton() {
      this.fields.buttonViewAll.color = '#ffffff';
    },
    handleResetBackgroundButton() {
      this.fields.buttonViewAll.background = '#2d521d';
    },
    handleResetItemTextColor() {
      this.fields.itemTextColor = '#000000';
    },
    handleResetItemBackground() {
      this.fields.itemBackground = '#ffffff';
    },
    handleChangeColorButton(event) {
      this.fields.buttonViewAll.color = event.target.value;
    },
    handleChangeBackgroundButton(event) {
      this.fields.buttonViewAll.background = event.target.value;
    },
    handleChangeItemTextColor(event) {
      this.fields.itemTextColor = event.target.value;
    },
    handleChangeItemBackground(event) {
      this.fields.itemBackground = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields.backgroundColor = '#ffffff';
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleResetTextColor() {
      this.fields.textColor = '';
    },
    handleChangePaginationActiveColor(event) {
      this.fields['pagination-active-color'] = event.target.value;
    },
    handleChangePaginationInactiveColor(event) {
      this.fields['pagination-inactive-color'] = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '#000000';
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '#cccccc';
    },
    handleAddItem() {
      this.fields['listItem'].push({
        url: '',
        image: '',
        title: '',
        description: '',
      });
    },
    handleRemoveItem(i) {
      this.fields['listItem'].splice(i, 1);
    },
    handleUploadImageItem(obj, i) {
      this.fields['listItem'][i].image = obj.imageSrc;
    },
    handleRemoveUploadItem(i) {
      this.fields['listItem'][i].image = '';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTinoGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 300px;
}

.ck-editor__editable {
  min-height: 300px;
}

.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}

.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}

.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
